module.exports = __webpack_public_path__ + "static/media/quieromibarriomini.ee2fb481.webp";